<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/DCLkob/tc-custom/9781534391932.jpg?1705950842914" alt="This image is the cover for the book Junk Rabbit, Junk Rabbit"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Junk Rabbit, Junk Rabbit
      </h1>
      <p class="bookDescription body article font2">
        <p>A new hero rises from mountains of consumer waste, the massive homeless population, and devastating climate change. Some call the hero a myth, an urban legend, but others know that it’s the JUNK RABBIT come to life! **JIMMIE ROBINSON** brings a new take to the dystopian tale of how climate disaster alters not only our world, but also the heroes that literally rise from it. **_Swamp Thing_** meets **_RoboCop_**! Collects **JUNK RABBIT #1-6**</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jimmie Robinson
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Image Comics
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?041a9b2f